<template>
    <div class="games">
        <v-card max-width="500" class="mx-auto" v-if="group">
            <v-card-actions>
                <v-btn text color="blue-grey" @click="goToMyPage">
                    <v-icon>mdi-arrow-left</v-icon>
                    <span class="ml-2">돌아가기</span>
                </v-btn>
                <v-spacer></v-spacer>

                 <!-- components -->                                
                <GroupImage
                    v-if="user.alias == group.creator.alias" 
                    :groupId="groupId"
                    :group="group"
                />

                <!-- menu -->
                <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" v-if="groupId != 'open-league'"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                    </template>

                    <v-list>
                        <v-list-item router :to="{ name: 'Signout', params: { group_id: groupId, group: group, user: user } }">
                            <v-list-item-content>
                            <v-list-item-subtitle>
                                <v-btn icon small>
                                <v-icon>mdi-logout</v-icon>
                                </v-btn>
                                <span class="ml-3">모임탈퇴</span>
                            </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <!-- <v-list-item v-if="user.alias == group.creator.alias">
                            <v-list-item-content>
                            <v-list-item-subtitle>
                                <v-btn icon small>
                                <v-icon>mdi-trash-can-outline</v-icon>
                                </v-btn>
                                <span class="ml-3">모임삭제</span>
                            </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item> -->
                    </v-list>
                </v-menu>
            </v-card-actions>

            <!-- parallax -->
            <v-parallax height="250" :src="group.imgURL">
                <v-card-title v-text="group.name" class="align-end fill-height white--text"></v-card-title>
                <v-card-text v-text="group.region"></v-card-text>                
            </v-parallax>
            
            <!-- component -->
            <CreatingGame v-if="remainder"/>

            <v-btn disabled v-if="!remainder" absolute dark fab right bottom class="pink accent-4">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-card>
        <v-card flat max-width="500" min-height="500" class="mx-auto mt-7">
            <v-tabs show-arrows v-if="games" v-model="tab" centered background-color="transparent">
                <v-tab>
                    <v-btn text small>게임</v-btn>
                </v-tab>
                <v-tab>
                    <v-btn text small>기록</v-btn>
                </v-tab>
                <v-tab>
                    <v-btn text small>회원</v-btn>
                </v-tab>
                <v-tab>
                    <v-btn text small>공지</v-btn>
                </v-tab>
                <v-tab>
                    <v-btn text small>대회</v-btn>
                </v-tab>

            </v-tabs>
            <v-tabs-items v-model="tab">

                <!-- games -->
                <v-tab-item>
                    <v-card flat class="mb-0 mt-3">
                        <v-card-actions @click="switchOn = !switchOn">
                            <v-spacer></v-spacer>
                            <!-- <h3 v-if="switchOn" class="overline blue-grey--text">내 게임</h3>  
                            <h3 v-if="!switchOn" class="overline blue-grey--text">전체 게임</h3>   -->
                            <v-btn text class="blue-grey--text">
                                <v-icon :color="switchOn ? 'blue-grey' : 'grey'">mdi-account</v-icon>
                                <v-icon color="grey">mdi-swap-horizontal</v-icon>
                                <v-icon :color="!switchOn ? 'blue-grey' : 'grey'">mdi-account-multiple</v-icon>                                
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                    <v-card flat class="mb-2 px-3" v-for="(game, index) in switchToMyGames" :key="game.timeStamp" :data-id="game.id">
                        <v-row align="center">
                            <v-col cols="1" class="text-center">
                                <span class="caption grey--text">{{ switchToMyGames.length - index }}.</span>
                            </v-col>
                            <v-col cols="4" class="text-center">
                                <span v-if="game.playerOne.result == 'win'" class="pink--text overline font-italic">{{ game.playerOne.result }}</span>  
                                <span v-if="game.playerOne.result == 'lose'" class="grey--text overline font-italic">{{ game.playerOne.result }}</span>
                                <span v-if="game.finished" class="overline blue-grey--text"> ({{ adjustingLevel(game.playerOne.total + game.playerOne.points) }}</span>
                                <span v-if="game.finished" class="overline blue-grey--text">, {{ game.playerOne.total + game.playerOne.points }})</span>
                                <v-responsive>
                                    <v-avatar size="40">
                                        <v-img :src="game.playerOne.avatar"></v-img>
                                    </v-avatar>
                                </v-responsive>
                                <span class="caption">{{game.playerOne.name }}</span>
                                <span class="overline blue-grey--text">({{game.playerOne.level}}, {{ game.playerOne.total }})</span>
                            </v-col>
                            <v-col cols="1">
                                <v-row justify="center" class="blue-grey--text font-italic">
                                VS
                                </v-row>
                            </v-col>
                            <v-col cols="4" class="text-center">
                                <span v-if="game.playerTwo.result == 'win'" class="pink--text overline font-italic">{{ game.playerTwo.result }}</span>
                                <span v-if="game.playerTwo.result == 'lose'" class="grey--text overline font-italic">{{ game.playerTwo.result }}</span>
                                <span v-if="game.finished" class="overline blue-grey--text"> ({{ adjustingLevel(game.playerTwo.total + game.playerTwo.points) }}</span>
                                <span v-if="game.finished" class="overline blue-grey--text">, {{ game.playerTwo.total + game.playerTwo.points }})</span>
                                <v-responsive>
                                    <v-avatar size="40">
                                        <v-img :src="game.playerTwo.avatar"></v-img>
                                    </v-avatar>
                                </v-responsive>
                                <span class="caption">{{ game.playerTwo.name }}</span>
                                <span class="overline blue-grey--text">({{game.playerTwo.level}}, {{ game.playerTwo.total }})</span>
                            </v-col>
                            <v-col cols="2">
                                <span v-if="!switchOn" class="overline indigo--text accent-4">{{ game.winner.name }}</span>
                                <div v-if="switchOn">

                                    <v-row>
                                        <v-col cols="12">
                                            <!-- components -->
                                            <Confirm
                                                v-if="!game.finished"
                                                :groupId="groupId"
                                                :gameId="game.id"
                                                :games="games"
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <DeleteGame v-if="!game.finished" :groupId="groupId" :gameId="game.id" />
                                            <h5 v-if="game.finished && game.winner.alias == user.alias" class="text-center">
                                                <span class="caption pink--text text--lighten-2">+{{ Math.abs(game.playerOne.points) }}</span>
                                            </h5>
                                            <h5 v-if="game.finished && game.winner.alias != user.alias" class="text-center">
                                                <span class="caption grey--text text-lighten-2">-{{ Math.abs(game.playerOne.points) }}</span>
                                            </h5>
                                        </v-col>
                                    </v-row>                                                              
                                </div>                                
                            </v-col>
                        </v-row>
                        <v-row v-if="!game.finished" justify="center">
                            <v-col cols="12">
                                <v-progress-linear
                                    color="orange accent-4"
                                    indeterminate
                                    buffer-value="100"
                                    rounded
                                    height="1"
                                ></v-progress-linear>
                            </v-col>
                        </v-row>
                        <v-divider v-if="game.finished"></v-divider>
                    </v-card>
                </v-tab-item>

                <!-- history -->
                <v-tab-item>
                    <v-card flat class="mx-auto mt-3">
                        <v-sheet
                            v-if="(user.wins+user.loses) > 0"
                            class="v-sheet--offset mx-auto"
                            color="cyan"
                            max-width="calc(100%)"
                        >
                            <v-sparkline
                                :labels="groupHistory"
                                :value="groupHistory"
                                stroke-linecap="round"
                                color="white"
                                type="trend"
                                line-width="2"
                                padding="16"
                                height="100"
                                auto-draw
                            ></v-sparkline>
                        </v-sheet>
                        <v-list  v-if="(user.wins+user.loses) > 0">
                            <v-subheader>상대와의 전적</v-subheader>
                            <v-divider inset></v-divider>
                            <v-list-item v-for="(opponent, i) in opponents" :key="i" @click="goToProfile()">
                                <v-list-item-icon>
                                    <v-btn small text>{{opponent.loses}}- {{opponent.wins}}</v-btn>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-progress-linear height="6" color="blue-grey accent-4" :value="(opponent.loses / (opponent.loses + opponent.wins)) * 100">
                                        </v-progress-linear>
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-content></v-list-item-content>
                                <v-list-item-content>
                                    <v-list-item-title v-text="opponent.name"></v-list-item-title>
                                    <v-list-item-subtitle v-text="opponent.alias"></v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-avatar>
                                    <v-img :src="opponent.avatar"></v-img>
                                </v-list-item-avatar>
                            </v-list-item>
                        </v-list>
                        <v-card-text v-else>
                            <p class="mt-2 font-italic">"A new commandment I give to you, that ye should love each other, just as I loved you, so that ye also should love each other."</p>
                            <p class="font-weight-bold text-right blue-grey--text">- John 13:34</p>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <!-- members -->
                <v-tab-item>
                    <div class="mx-3 mt-5 mb-0">
                        <v-text-field outlined label="Search" append-icon="search" v-model="search">
                        </v-text-field>
                    </div>
                    <v-list two-line dense subheader>
                        <v-subheader>Players({{ players.length }})</v-subheader>
                        <v-divider inset></v-divider>

                        <v-list-item v-for="player in searchedPlayer" :key="player.id">
                            <v-list-item-avatar>
                                <v-img :src="player.avatar"></v-img>
                            </v-list-item-avatar>

                            <v-list-item-content>
                            <v-list-item-title v-text="player.name"></v-list-item-title>
                            <v-list-item-subtitle v-text="player.alias"></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-content>
                                <v-list-item-title v-text="player.total"></v-list-item-title>
                                <v-list-item-subtitle>
                                    <span v-text="player.level"></span>부
                                    <span v-for="n in player.level" :key="n">
                                        <v-icon small color="orange">mdi-star</v-icon>
                                    </span>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                                <!-- component -->
                                <Profile :playerId="player.id" :players="players" />
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-tab-item>
                
                <!-- bulletin -->
                <v-tab-item>
                    <v-container>
                        <!-- component -->
                        <CreatingNotice
                            v-if="group && user.alias == group.creator.alias" 
                            :groupId="groupId"
                            :user="user"
                            :notices="notices"
                        />
                        <v-list v-if="notices.length > 0">
                            <v-subheader>모임소개</v-subheader>
                            <v-list-item v-for="notice in noticesIntro" :key="notice.timeStamp" @click="goToProfile">
                                <v-list-item-action></v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-text="notice.title"></v-list-item-title>
                                    <v-list-item-subtitle v-text="notice.content"></v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-icon>
                                    <v-icon v-text="notice.icon"></v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-subheader>연락처</v-subheader>
                            <v-list-item v-for="notice in noticesPhones" :key="notice.timeStamp" @click="goToProfile">
                                <v-list-item-action></v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-text="notice.title"></v-list-item-title>
                                    <v-list-item-subtitle v-text="notice.content"></v-list-item-subtitle>
                                </v-list-item-content>
                                    <v-list-item-icon>
                                    <v-icon v-text="notice.icon"></v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-subheader>기타</v-subheader>
                            <v-list-item v-for="notice in noticesOthers" :key="notice.timeStamp" @click="goToProfile">
                                <v-list-item-action></v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-text="notice.title"></v-list-item-title>
                                    <v-list-item-subtitle v-text="notice.content"></v-list-item-subtitle>
                                </v-list-item-content>
                                    <v-list-item-icon>
                                    <v-icon v-text="notice.icon"></v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list>
                    </v-container>
                </v-tab-item>

                <!-- contest -->
                <v-tab-item>
                    <v-container>

                        <!-- component -->
                        <CreatingMonthlyContest
                            v-if="group && user.alias == group.creator.alias" 
                            :groupId="groupId"
                            :group="group"
                            :user="user"
                            :contests="contests"
                        />
                        <v-expansion-panels focusable v-if="contests">
                            <v-expansion-panel v-for="(contest, i) in contests" :key="i">
                                <v-expansion-panel-header>{{ contest.title }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card flat>
                                        <v-img
                                            class="white--text align-end mt-7"
                                            height="200px"
                                            :src="contest.image"
                                            >
                                        </v-img>
                                        <v-card-text>
                                            <v-list>
                                                <v-subheader>대회소개</v-subheader>
                                                <v-divider></v-divider>
                                            </v-list>
                                            <v-list-item> 
                                                <v-list-item-action></v-list-item-action>                                               
                                                <v-list-item-content>
                                                    <v-list-item-title>시간</v-list-item-title>
                                                    <v-list-item-subtitle class="purple--text" v-text="contest.time"></v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-icon>
                                                    <v-icon>mdi-clock-outline</v-icon>
                                                </v-list-item-icon>                                                
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-action></v-list-item-action>                                                
                                                <v-list-item-content>
                                                    <v-list-item-title>장소</v-list-item-title>
                                                    <v-list-item-subtitle v-text="contest.location"></v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-icon>
                                                    <v-icon>mdi-map-marker-radius</v-icon>
                                                </v-list-item-icon>                                                                                       
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-action></v-list-item-action>                                                
                                                <v-list-item-content>
                                                    <v-list-item-title>회비</v-list-item-title>
                                                    <v-list-item-subtitle v-text="contest.fee"></v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-icon>
                                                    <v-icon>mdi-cash-100</v-icon>
                                                </v-list-item-icon>                                        
                                            </v-list-item>
                                            <v-divider></v-divider>
                                        </v-card-text>
                                        <v-card-text>
                                            <v-list>
                                                <v-subheader>참가자 명단 ({{ contest.applicants.length }})</v-subheader>
                                                <v-list-item v-for="(applicant, i) in contest.applicants" :key="i">
                                                    <v-list-item-avatar>
                                                        <v-img :src="applicant.avatar"></v-img>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                        <v-list-item-title v-text="applicant.name"></v-list-item-title>
                                                        <v-list-item-subtitle v-text="applicant.alias"></v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-content>
                                                        <v-list-item-title v-text="applicant.level"></v-list-item-title>
                                                        <v-list-item-subtitle v-text="applicant.total"></v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-icon>
                                                        <v-icon
                                                            v-if="user.alias == applicant.alias"
                                                            @click="byeContest(applicant, contest.id)"
                                                        >mdi-logout-variant</v-icon>
                                                    </v-list-item-icon>
                                                </v-list-item>
                                            </v-list>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="orange" @click="joinContest(contest.id)">참가하기</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>                                        
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-container>
                </v-tab-item>
                    
            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'
import slugify from 'slugify'
import CreatingGame from '@/components/CreatingGame'
import Confirm from '@/components/Confirm'
import DeleteGame from '@/components/DeleteGame'
import GroupImage from '@/components/GroupImage'
import CreatingMonthlyContest from '@/components/CreatingMonthlyContest'
import CreatingNotice from '@/components/CreatingNotice'
import Profile from '@/components/Profile'

import moment from 'moment'

export default {
    name: 'Games',
    components: { CreatingGame, DeleteGame, Confirm, GroupImage, CreatingMonthlyContest, CreatingNotice, Profile},
    data: () => ({
        tab: null,
        groupId: null,
        group: null,
        games: [],
        user: '',
        switchOn: true,
        players: [],
        slugs: [],
        aliases: [],
        search: '',
        groupHistory: [],
        contests: [],
        notices: [],
        levelRating: [
            { level: 0, ratingMin: 1900, ratingMax: 3000 },
            { level: 1, ratingMin: 1840, ratingMax: 1899 },
            { level: 2, ratingMin: 1780, ratingMax: 1839 },
            { level: 3, ratingMin: 1720, ratingMax: 1779 },
            { level: 4, ratingMin: 1640, ratingMax: 1719 },
            { level: 5, ratingMin: 1500, ratingMax: 1639 },
            { level: 6, ratingMin: 1300, ratingMax: 1499 },
            { level: 7, ratingMin: 1100, ratingMax: 1299 },
            { level: 8, ratingMin: 900, ratingMax: 1099 },
            { level: 9, ratingMin: 800, ratingMax: 899 },
            { level: 10, ratingMin: 700, ratingMax: 799 }
        ]    
    }),
    created(){
        // get the 'id' of the group
        this.groupId = this.$route.params.group_id;

        // get the current user
        let user = firebase.auth().currentUser;

        if(user){
        // find the user from firestore
        db.collection('users').where('user_id', '==', user.uid).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    this.user = {
                        ...doc.data(),
                        id: doc.id
                    }
                })
            }).then(() => {

                // find the group among the user's groups
                this.user.joinedGroups.forEach(group => {
                    if(group.id == this.groupId){
                        this.groupHistory = group.history
                    }
                })

                // find the players of this group
                db.collection('groups').doc(this.groupId).get().then(group => {
                    this.group = group.data();
                    let members = group.data().members
                    members.forEach(member => {
                        this.aliases.push(member.alias);
                    })
                }).then(() => {
                    // turn alias into slugs
                    this.slugs = this.aliases.map(alias => {
                        return slugify(alias, {
                            replacement: '-',
                            remove: /[$*_+~.()'"!\-:@]/g,
                            lower: true
                        })
                    })
                    this.slugs.forEach(slug => {
                        db.collection('users').doc(slug).get().then(player => {
                            this.players.push({
                                ...player.data(),
                                id: player.id
                            });
                        })
                    })
                })
            })
        } else {
            return false
        }

        
        // db.collection('groups').doc(this.groupId).get().then(doc => {
        //     this.group = doc.data();
        // })
        // get all the games of the group
        db.collection('games').where('group', '==', this.groupId).orderBy('timeStamp').onSnapshot(snapshot => {
            let changes = snapshot.docChanges();
            changes.forEach(change => {
                // console.log(change)
                if(change.type == 'added'){
                    this.games.unshift({
                        ...change.doc.data(),
                        id: change.doc.id
                    });
                } else if(change.type == 'removed'){
                    this.games = this.games.filter(game => {
                        return game.id != change.doc.id;
                    })
                } 
                else if(change.type == 'modified'){
                    // console.log('modified')
                    this.games = this.games.filter(game => {
                        return game.id != change.doc.id;
                    })
                    this.games.unshift({
                        ...change.doc.data(),
                        id: change.doc.id
                    });                        
                }
            })
        })

        // get the contests
        db.collection(this.groupId + '-contests').orderBy("created").onSnapshot(snapshot => {
            let changes = snapshot.docChanges();
            changes.forEach(change => {
                if(change.type == 'added'){
                    this.contests.unshift({
                        ...change.doc.data(),
                        id: change.doc.id
                    })
                } else if(change.type == 'removed'){
                    this.contests = this.contests.filter(notice => {
                        return notice.id != change.doc.id
                    })
                }
            })
        })

        // get notices
        db.collection(this.groupId + '-notices').orderBy("timeStamp").onSnapshot(snapshot => {
            let changes = snapshot.docChanges();
            changes.forEach(change => {
                if(change.type == 'added'){
                    this.notices.push({
                        ...change.doc.data(),
                        id: change.doc.id
                    })
                } else if(change.type == 'removed'){
                    this.notices = this.notices.filter(notice => {
                        return notice.id != change.doc.id
                    })
                }
            })
        })
    },
    methods: {
        turnSwitchOn(){
            this.switchOn = true;
        },
        turnSwitchOff(){
            this.switchOn = false;
        },
        momentjs(timeStamp){
            return moment(timeStamp).format('ll');
        },
        goToMyPage(){
            this.$router.push({ name: 'MyPage' })
        },
        joinContest(id){
            
            // update ui
            let applicants = [];
            this.contests.forEach(contest => {
                if(contest.id == id){

                    // check if there is already the user among the applicants
                    let none = contest.applicants.every(applicant => {
                        return applicant.alias != this.user.alias
                    })
                    if(none){
                        contest.applicants.push(this.user)
                        applicants = contest.applicants 
                    }
                }
            })

            // update firestore
            db.collection(this.groupId + '-contests').doc(id).update({
                applicants: applicants
            })
        },
        byeContest(user, id){
            // update ui
            let applicants = []
            this.contests.forEach(contest => {
                if(contest.id == id){
                    contest.applicants.splice(contest.applicants.indexOf(user), 1)
                    applicants = contest.applicants
                }
            })

            // update firestore
            db.collection(this.groupId + '-contests').doc(id).update({
                applicants: applicants
            })
        },
        goToProfile(){
            // console.log('go to profile')
        },
        adjustingLevel(newTotal){
            // console.log(newTotal)
            let newLevel = null;
            this.levelRating.forEach(item => {
                if(newTotal >= item.ratingMin && newTotal <= item.ratingMax){
                   newLevel = item.level;
                }
            });
            return newLevel;
        },
    },
    computed: {
        switchToMyGames(){
            if(this.switchOn == true){
                return this.games.filter(game => {
                    return game.playerOne.alias.match(this.user.alias) || game.playerTwo.alias.match(this.user.alias)
                })
            } else {
                return this.games;
            }
        },
        searchedPlayer(){
            return this.players.filter(player => {
                return player.name.match(this.search) || player.alias.match(this.search)
            })
        },
        remainder(){
            return this.switchToMyGames.every(game => {
                return game.finished == true;
            })
        },
        opponents(){

            // get opponents
            let opponents = [];
            this.games.forEach(game => {
                if(game.finished == true && (game.winner.alias == this.user.alias || game.loser.alias == this.user.alias)){
                    let opponent = null;
                    if(game.winner.alias == this.user.alias && game.winner.alias == game.playerOne.alias){
                        opponent = {
                            name: game.loser.name,
                            alias: game.loser.alias,
                            avatar: game.playerTwo.avatar,
                            win: 0,
                            lose: 1
                        }
                    } else if(game.winner.alias == this.user.alias && game.winner.alias == game.playerTwo.alias){
                        opponent = {
                            name: game.loser.name,
                            alias: game.loser.alias,
                            avatar: game.playerOne.avatar,
                            win: 0,
                            lose: 1
                        }
                    } else if(game.loser.alias == this.user.alias && game.loser.alias == game.playerOne.alias){
                        opponent = {
                            name: game.winner.name,
                            alias: game.winner.alias,
                            avatar: game.playerTwo.avatar,
                            win: 1,
                            lose: 0
                        }
                    } else if(game.loser.alias == this.user.alias && game.loser.alias == game.playerTwo.alias){
                        opponent = {
                            name: game.winner.name,
                            alias: game.winner.alias,
                            avatar: game.playerOne.avatar,
                            win: 1,
                            lose: 0
                        }
                    }
                    // push the opponent into
                    opponents.push(opponent);
                }
            })

            // console.log(opponents)

            // sort out the opponents
            let sortedOpponents = [
                // { name: joe, alias: niceJoe, wins: 6, loses 3 s},
                // { name: joe, alias: niceJoe, wins: 6, loses 3 s},
                // { name: joe, alias: niceJoe, wins: 6, loses 3 s},
            ];
            opponents.forEach(opponent => {

                // check if there is a existing one
                let existing = sortedOpponents.some(sortedOpponent => {
                   return opponent.alias == sortedOpponent.alias
                })

                if(existing){
                    let index = null;
                    sortedOpponents.forEach((sortedOpponent, i) => {
                        if(opponent.alias == sortedOpponent.alias){
                            index = i;
                        }
                    })

                    sortedOpponents[index].wins += opponent.win
                    sortedOpponents[index].loses += opponent.lose
                } else {
                    sortedOpponents.push({
                        name: opponent.name,
                        alias: opponent.alias,
                        avatar: opponent.avatar,
                        wins: opponent.win,
                        loses: opponent.lose
                    })
                }
               
            })

            return sortedOpponents;
        },
        noticesIntro(){
            return this.notices.filter(notice => {
                return notice.header == "모임소개"
            })
        },
        noticesPhones(){
            return this.notices.filter(notice => {
                return notice.header == "연락처"
            })
        },
        noticesOthers(){
            return this.notices.filter(notice => {
                return notice.header == "기타"
            })
        }
    }
};
</script>

<style>

.v-btn--fab{
    z-index: -1;
}

</style> 